export enum CustomSizes {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  lARGE = 'LARGE',
}
